import React from 'react';
import { Button, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap';

var SearchForm = function SearchForm(_ref) {
  var method = _ref.method,
      onSearchQueryChanged = _ref.onSearchQueryChanged,
      performSearch = _ref.performSearch,
      searchParameterName = _ref.searchParameterName,
      searchURL = _ref.searchURL;
  return /*#__PURE__*/React.createElement(Form, {
    action: searchURL,
    inline: true,
    method: method,
    onSubmit: performSearch
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    "for": "search",
    hidden: true
  }, "Search"), /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(Input, {
    name: searchParameterName,
    onChange: onSearchQueryChanged,
    placeholder: "Search",
    type: "search"
  }), /*#__PURE__*/React.createElement(InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/React.createElement(Button, null, "Search")))));
};

SearchForm.defaultProps = {
  searchParameterName: 'search'
};
export default SearchForm;